import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/Approutes.js";
import "./styles/master-styles.css"; // Solo el archivo maestro

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
export default App;
